import { useConfiguracoes } from '@/features/configuracoes/hooks/useConfiguracoes';

/**
 * Dia de início do período de produção do tenant (ex.: 21 = ciclo de 21 do mês anterior a 20 do mês).
 * Fonte única para telas, filtros e dashboards.
 */
export function useProductionStartDay(): number {
  const { state: { tenantSettings } } = useConfiguracoes();
  return tenantSettings?.dia_inicio_producao || 1;
}
